// Şube Rezervasyon İstekleri kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'reservations.requests';

export const reservationRequestsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Rezervasyon istekleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfa şubenize gelen online bilet / rezervasyon isteklerini takvimde gösterir. Bekleyen istekleri buradan onaylar veya reddedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Renk açıklamaları'),
    filters: t(`${G}.regions.filters`, 'Önceki / Bugün / Sonraki, Gün · Hafta · Ay'),
    table: t(`${G}.regions.table`, 'İstek takvimi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Gün, hafta veya ay görünümü'),
      text: t(`${G}.s1.text`, 'Takvim ay görünümüyle açılır. Sağdaki simgelerle Gün, Hafta veya Ay görünümüne geçin; oklarla önceki / sonraki döneme gidin, ortadaki düğmeyle bugüne dönün.'),
      tips: [
        t(`${G}.s1.tip1`, 'Her istek rezervasyon gününde 1 saatlik blok olarak görünür; istekte saat yoksa 10:00\'da gösterilir.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Renkleri okuyun'),
      text: t(`${G}.s2.text`, 'Başlığın altındaki açıklama renkleri gösterir: Onaylanmış (yeşil), Onay Bekleyen (mavi), Çakışma (turuncu), Reddedilmiş (kırmızı), Kullanılmış (mor).'),
      tips: [
        t(`${G}.s2.tip1`, 'Çakışma: bekleyen bir istek, aynı saatlerdeki onaylanmış veya kullanılmış bir rezervasyonla örtüşüyor demektir. Onaylamadan önce kontrol edin.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Talep detayını açın'),
      text: t(`${G}.s3.text`, 'Takvimdeki bir isteğe tıklayınca Rezervasyon Detayları açılır. "Rezervasyon Bilgileri" sekmesinde Başlangıç ve Bitiş Zamanı, "Müşteri Bilgileri" sekmesinde Müşteri Adı, Telefon ve E-posta görünür.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Onaylayın veya reddedin'),
      text: t(`${G}.s4.text`, 'Yalnız Onay Bekleyen isteklerde "Onayla" ve "Reddet" düğmeleri çıkar. Seçiminizi onay penceresinde doğrulayın; isteğin durumu kaydedilir ve takvimdeki rengi hemen değişir (onaylanan yeşil, reddedilen kırmızı).'),
      tips: [
        t(`${G}.s4.tip1`, 'Ödemesi başarıyla alınmış bir rezervasyon reddedilemez.'),
        t(`${G}.s4.tip2`, 'Onaylanan istek, Müsait Saatler takvimindeki müsaitlikleri değiştirmez; müsaitlikleri ayrıca düzenlemeniz gerekir.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Müsait saatlere dönün'),
      text: t(`${G}.s5.text`, 'Sol üstteki geri oku sizi bu şubenin Müsait Saatler (rezervasyon takvimi) sayfasına götürür.'),
    },
  ],
});
